// ** Initial State
const initialState = {
  data: [],
  bank: [],
  bankcategory: [],
  category: [],
  agent: []
}

const agent = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENT_GET_DATA':
      return {
        ...state,
        data: action.data
      }
    case 'AGENT_BANK':
      return {
        ...state,
        bank: action.data
      }
    case 'AGENT_GATEGORY':
      return {
        ...state,
        category: action.data
      }
    case 'AGENT_BANK_GATEGORY':
      return {
        ...state,
        bankcategory: action.data
      }
    case 'TRANSFER_PARTNER_GET_DATA':
      return {
        ...state,
        data: action.data
      }
    case 'SELECT_AGENTID':
      return {
        ...state,
        agent: action.agent
      }
    default:
      return { ...state }
  }
}

export default agent